export default __webpack_public_path__ + "static/media/slide-7.1aac625c.jpeg";